import { useRef } from "react";
import { Button, type ButtonVariant } from "@sdcp/ui";

export interface UploadButtonProps {
  label: string;
  busy?: boolean;
  onPick: (file: File) => void;
  /** Primary when uploading *is* the requirement's own path, not an alternative. */
  variant?: ButtonVariant;
}

/**
 * The manual-upload path.
 *
 * `capture` is deliberately absent: a borrower photographing a document usually
 * has it already in their camera roll, and forcing the camera makes that
 * impossible.
 */
export function UploadButton({
  label,
  busy = false,
  onPick,
  variant = "secondary",
}: UploadButtonProps) {
  const input = useRef<HTMLInputElement>(null);

  return (
    <>
      <input
        ref={input}
        type="file"
        accept=".pdf,.jpg,.jpeg,.png,.heic,application/pdf,image/*"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0];
          // Reset so picking the same file twice still fires a change event —
          // which is what happens after a rejected upload.
          e.target.value = "";
          if (file) onPick(file);
        }}
      />
      <Button variant={variant} disabled={busy} onClick={() => input.current?.click()}>
        {label}
      </Button>
    </>
  );
}
